(() => {
  if (window.UWSStockDisplay) return;
  const colors = {red:'#D50032','cherry red':'#AC2B37','dark chocolate':'#382F2D',maroon:'#6F263D','forest green':'#273B33',schwarz:'#000',black:'#000',noir:'#000',negro:'#000',nero:'#000',weiß:'#fff',white:'#fff',blanc:'#fff',blanco:'#fff',bianco:'#fff',pink:'#f58ac3',rose:'#f58ac3',rosa:'#f58ac3',hellblau:'#8ac3d9','light blue':'#8ac3d9','bleu clair':'#8ac3d9','azul claro':'#8ac3d9',azzurro:'#8ac3d9',navy:'#010922','bleu marine':'#010922','azul marino':'#010922','blu navy':'#010922',army:'#474841','army green':'#474841','vert militaire':'#474841','verde militar':'#474841','verde militare':'#474841',chocolate:'#140b07',chocolat:'#140b07',cioccolato:'#140b07',sand:'#cabfad',sable:'#cabfad',arena:'#cabfad',sabbia:'#cabfad','garnet red':'#7d2935','rouge grenat':'#7d2935','rojo granate':'#7d2935','rosso granata':'#7d2935','light pink':'#e4c6d4','rose clair':'#e4c6d4','rosa claro':'#e4c6d4','rosa chiaro':'#e4c6d4'};
  const colorKey = value => colors[String(value).toLowerCase()] || String(value).toLowerCase();
  const equal = (a,b,i) => i === 0 ? colorKey(a) === colorKey(b) : a === b;
  const setAttr = (el,k,v) => { if(el.getAttribute(k)!==String(v))el.setAttribute(k,String(v)); };
  const text = (el,value) => { if(el.textContent!==value)el.textContent=value; };
  function sold(variants,values) {
    if(!values[0])return false;
    return !variants.some(v=>v.available&&values.every((x,i)=>!x||equal(v.options[i],x,i)));
  }
  function priceBadge(info,unavailable,label) {
    const price=info?.querySelector('[id^="price-"] .price') || info?.querySelector('.price');
    if(!price)return;
    price.classList.toggle('price--sold-out',unavailable);
    const native=price.querySelector('.price__badge-sold-out');
    if(native){native.hidden=!unavailable;return;}
    let badge=price.querySelector('[data-uws-stock-badge]');
    if(!badge){badge=document.createElement('span');badge.className='uws-stock-badge';badge.dataset.uwsStockBadge='';price.append(badge);}
    text(badge,label);badge.hidden=!unavailable;
  }
  window.UWSStockDisplay={sold,priceBadge};
  document.querySelectorAll('[data-uws-stock-config]').forEach(config=>{
    if(config.dataset.mounted)return;
    config.dataset.mounted='true';
    const data=JSON.parse(config.textContent),info=config.closest('product-info')||config.closest('[id^="ProductInfo"]');
    const root=info?.querySelector('#uws-pair,#ml-pair');
    if(!root){const christmas=info?.querySelector('uws-christmas-pair');christmas?.updateFirstImage?.();christmas?.updateTotal?.();return;}
    const cards=[...root.querySelectorAll('.uws-shirt-card,.ml-card')];
    const groups=cards.map(card=>({card,selects:[...card.querySelectorAll('select')],buttons:[]}));
    groups.forEach(group=>group.selects.forEach((select,i)=>{
      const holder=document.createElement('div');holder.className='uws-stock-choices';holder.setAttribute('role','group');
      const label=root.querySelector(`label[for="${select.id}"]`);holder.setAttribute('aria-label',label?.textContent||'');
      [...select.options].filter(o=>o.value).forEach(option=>{
        const b=document.createElement('button');b.type='button';b.dataset.stockValue=option.value;b.className='uws-stock-choice'+(i===0?' uws-stock-color':'');
        if(i===0)b.style.setProperty('--stock-color',colors[option.value.toLowerCase()]||'#ddd');else b.textContent=option.value;
        b.addEventListener('click',()=>{
          if(select.disabled)return;
          select.value=option.value;
          select.dispatchEvent(new Event('change',{bubbles:true}));
          if(i===0&&root.id==='ml-pair'){
            const variant=data.variants.find(v=>equal(v.options[0],option.value,0)&&v.featured_media?.id);
            const gallery=document.getElementById(info.id.replace(/^ProductInfo-/,'MediaGallery-'));
            const media=variant&&gallery?.querySelector('[data-media-id$="-'+variant.featured_media.id+'"]');
            if(media)gallery.setActiveMedia?.(media.dataset.mediaId,false);
          }
          schedule();
        });
        holder.append(b);group.buttons.push({b,option,select,index:i});
      });
      select.after(holder);select.classList.add('uws-stock-native');
    }));
    let queued=false;
    function schedule(){if(queued)return;queued=true;queueMicrotask(()=>{queued=false;refresh();});}
    const purchaseIds=root.id==='ml-pair'?['ml-add','ml-dialog-add']:['uws-pair-add','uws-pair-add-inline'];
    const originals=new Map();
    function refresh(){
      const single=document.getElementById('ml-single')?.checked;
      let unavailable=false;
      groups.forEach((group,n)=>{
        const values=group.selects.map(s=>s.value);
        if((!single||n===0)&&sold(data.variants,values))unavailable=true;
        group.buttons.forEach(({b,option,select,index})=>{
          const candidate=index===0?[option.value,'']:[values[0],option.value];
          const out=index===0?sold(data.variants,candidate):!!values[0]&&sold(data.variants,candidate);
          b.classList.toggle('uws-stock-sold',out);
          setAttr(b,'aria-pressed',select.value===option.value);
          const label=option.textContent.replace(/ · (ausverkauft|sold out|épuisé|agotado|esaurito)$/i,'');
          setAttr(b,'aria-label',label+(out?' – '+data.soldOut:''));b.title=label+(out?' – '+data.soldOut:'');
          const disabled=select.disabled||(index>0&&(!values[0]||out));if(b.disabled!==disabled)b.disabled=disabled;
        });
      });
      priceBadge(info,unavailable,data.soldOut);
      purchaseIds.forEach(id=>{const b=document.getElementById(id);if(!b)return;
        if(unavailable){if(b.textContent!==data.soldOut)originals.set(b,b.textContent);text(b,data.soldOut);if(!b.disabled)b.disabled=true;}
        else if(originals.has(b)){if(b.textContent===data.soldOut)text(b,originals.get(b));originals.delete(b);}
      });
    }
    root.addEventListener('change',schedule);
    new MutationObserver(schedule).observe(root,{subtree:true,attributes:true,attributeFilter:['disabled','hidden']});
    for(const id of purchaseIds){const b=document.getElementById(id);if(b)new MutationObserver(schedule).observe(b,{attributes:true,attributeFilter:['disabled'],childList:true,characterData:true,subtree:true});}
    refresh();
  });
})();
